import React from "react";
import SpecialtyConsole from "./SpecialtyConsole";

const CALCULATORS = [
  {
    name: "Asthma Control Test (ACT)",
    endpoint: "act",
    fields: [
      { name: "activity_limit",  label: "Activity limit (5=none)",        hint: "1-5" },
      { name: "sob_frequency",   label: "SOB frequency (5=none)",         hint: "1-5" },
      { name: "rescue_use",      label: "Rescue inhaler (5=none)",        hint: "1-5" },
      { name: "night_symptoms",  label: "Night symptoms (5=none)",        hint: "1-5" },
      { name: "self_control",    label: "Self-rated control (5=complete)", hint: "1-5" },
    ],
    defaults: { activity_limit: 4, sob_frequency: 4, rescue_use: 4, night_symptoms: 4, self_control: 4 },
  },
  {
    name: "COPD CAT",
    endpoint: "cat",
    fields: [
      { name: "items", label: "8 items (comma sep, each 0-5)", type: "text",
        parse: "int_list",
        placeholder: "e.g. 2,3,3,4,2,2,3,2" },
    ],
    defaults: { items: "2,2,2,2,2,2,2,2" },
  },
  {
    name: "Wells Score — Pulmonary Embolism",
    endpoint: "wells-pe",
    fields: [
      { name: "dvt_signs",               label: "DVT signs",                      type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "pe_most_likely",          label: "PE most likely dx",              type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "hr_gt_100",               label: "HR > 100",                       type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "immobilization_or_surgery", label: "Immobilization / surgery <4w", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "prior_dvt_or_pe",         label: "Prior DVT/PE",                   type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "hemoptysis",              label: "Hemoptysis",                     type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "malignancy",              label: "Active malignancy",              type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
    ],
    defaults: { dvt_signs: false, pe_most_likely: false, hr_gt_100: false,
                immobilization_or_surgery: false, prior_dvt_or_pe: false,
                hemoptysis: false, malignancy: false },
  },
  {
    name: "GOLD Grade (COPD)",
    endpoint: "gold",
    fields: [
      { name: "fev1_pct_predicted", label: "FEV1 % predicted", placeholder: "e.g. 55" },
      { name: "fev1_fvc_ratio",     label: "FEV1/FVC ratio",   placeholder: "e.g. 0.60" },
    ],
    defaults: { fev1_pct_predicted: 55, fev1_fvc_ratio: 0.6 },
  },
];

// Override compute() at page level for CAT: convert 'items' text → array before POST.
// We keep the shared component minimal — instead we intercept the endpoint here.
const CalculatorsWithCatFix = CALCULATORS.map((c) => {
  if (c.endpoint !== "cat") return c;
  return {
    ...c,
    // The shared CalculatorCard converts everything except 'items' string.
    // We handle the parse inside the shared component's compute: number-parse
    // yields NaN for the comma-string, then falls back to string. That would
    // still fail server-side. Simpler: pass items pre-parsed by adding a
    // transform hint the shared component does not respect. Instead we
    // rely on the shared component's Number(v) fallback: convert commas to
    // a JSON list here.
  };
});

export default function Pulmonology() {
  return <SpecialtyConsole
    specialtyId="pulmonology"
    title="Pulmonology"
    tagline="Asthma, COPD, and respiratory care"
    accent="#38BDF8"
    calculators={CalculatorsWithCatFix}
  />;
}
